import React from 'react';
import { FaCheck, FaPen, FaTimes } from 'react-icons/fa';

/**
 * Action Column with edit / save / cancel Buttons
 * @param param0
 * @returns
 */
export const EditCellV8 = ({ row, table }) => {
  const meta = table.options.meta;
  const doCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Ακύρωση
    meta.cancelRow(row.id);
  };

  const doEdit = (e: React.MouseEvent<HTMLButtonElement>) => {
    meta.editRow(row.id);
  };

  const doSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Save
    meta.saveRow(row.index);
  };

  const anotherRowIsEditing = (rowId, editedRows) => {
    let isEditing = false;
    for (const [key, value] of Object.entries(editedRows)) {
      if (key !== rowId) {
        isEditing = true;
        break;
      }
    }
    return isEditing;
  };

  return (
    <div className="edit-cell-container text-center">
      {meta?.editedRows[row.id] && !anotherRowIsEditing(row.id, meta?.editedRows) ? (
        <div className="edit-cell">
          <button onClick={doSave} name="done" type="button">
            <FaCheck />
          </button>
          <button className="ms-1" onClick={doCancel} name="cancel">
            <FaTimes />
          </button>
        </div>
      ) : (
        <button onClick={doEdit} name="edit">
          <FaPen />
        </button>
      )}
    </div>
  );
};

/**
 * TableCellV8
 * @param param0
 * @returns
 */
type Option = {
  label: string;
  value: string;
};
/*
  export const TableCellV8 = ({ getValue, row, column, table }) => {
    const initialValue = getValue();
    const columnMeta = column.columnDef.meta;
    const tableMeta = table.options.meta;
    const [value, setValue] = useState(initialValue);
    useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);
    const onBlur = () => {
      tableMeta.updateData(row.index, column.id, value, row.original);
      //tableMeta.setChangedData(row.index, column.id, value, row.original);
    };
    const onSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
      setValue(e.target.value);
      tableMeta.updateData(row.index, column.id, e.target.value, row.original);
    };
    if (tableMeta.editedRows[row.id]) {
      return columnMeta?.type === 'select' ? (
        <select onChange={onSelectChange} value={initialValue}>
          {columnMeta?.options?.map((option: Option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          className="form-control"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={onBlur}
          type={columnMeta?.type || 'text'}
        />
      );
    }
    return <span>{value}</span>;
  };
  */

